const imgTeamGraphic2Guidecards = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img12032 = "./assets/figma/7f2a7ce8-be0d-428a-8606-8c1344abe439.png";
const img2026923382 = "./assets/figma/221a0709-28db-4d8c-a722-6c06f1ed6284.png";
const img2026923372 = "./assets/figma/06d5533b-ffa3-4942-a40c-4910afc87dee.png";
const img2026923373 = "./assets/figma/01051303-3827-4a66-ab58-6b9c95b95078.png";
const img2026923383 = "./assets/figma/418cccde-c404-479a-9d33-5dd4ffac3b77.png";
const img2026923384 = "./assets/figma/499d08db-cdaa-42da-9329-1fa92527a224.png";
const img2026923385 = "./assets/figma/10b9af6d-7016-4cc1-bdab-56e95e2535e6.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const img15Png1 = "./assets/figma/1a3b68a3-6e0e-4b18-8d4d-4cdacf65ccfa.png";
const img16Png1 = "./assets/figma/d7945169-6801-4674-a697-2da1cca2eb71.png";
const img121 = "./assets/figma/0434cd2c-fba0-45c2-a1e2-73d2567fdd66.png";
const imgB2Df68766D6942FdA6E82737476A81E51 = "./assets/figma/fa0ff002-b3ba-4c52-bd37-6ddb00d103e5.png";
const img06A88D4FCcce45Ee9F2494B91A0833581 = "./assets/figma/617af9d1-0f0d-4048-b960-033ab34e0b38.png";
const img31Fe81D3Da824D5486716Fbd4D48C0021 = "./assets/figma/bc22af17-1121-4654-9bcd-462c472ae032.png";
const img90Cc8E1E47064Ddd945F67B8Da51C4D61 = "./assets/figma/2ab7f8e9-d6f7-41f0-b66a-4c8cea7f6a94.png";
const imgA35715BcEfda49A49D8E82Df03968D501 = "./assets/figma/129d46c9-9aa9-429c-b79f-fd3be09216ca.png";
const img1C7920CdBdb14369A01E4B60B7E0F0Df1 = "./assets/figma/660a8600-ed36-44b8-ba33-702476c6db1c.png";
const img92C4E9F60Fed48D8A273F8F5B32C821C1 = "./assets/figma/bf349510-07d0-4640-860f-949064a04502.png";
const img9Cdc4E6B87D24719A321E1F4152D1C8D1 = "./assets/figma/a775435c-3f0b-4cb9-aae7-8630190c6ffb.png";
const imgDa3E057C95Cc44C8Ab31B10703C92C951 = "./assets/figma/694cfb8f-5d6b-43ea-8768-ddacb97372aa.png";
const img9E2Bbb1C4F5F4835A412Ee904Cca12091 = "./assets/figma/cae012e2-6cb2-45c9-a995-21e4ff78195b.png";
const imgE143E6B0B96B402D9315B91D7293Dd2E1 = "./assets/figma/0d7ddedf-4027-4a3d-9fb2-5f3a5a7452d0.png";
const img4E95026AEd7146AdB74AEe7C976Ab2Fd1 = "./assets/figma/a1460016-7d19-48fd-8cce-90d3d56188fc.png";
const imgB6B883Ad3Bea4450A00199614F62Fb771 = "./assets/figma/f34df928-aa02-4a5f-ae6f-fb1bc58a898b.png";
const img1F045125Db604Ef98344E667C966F24A1 = "./assets/figma/3f6bf276-34d9-47bd-ab45-ce2cc46e83c6.png";
const imgC043Ddf8D37F4Be0952B565204E4Abd41 = "./assets/figma/0674d672-bef5-4bc0-82e2-cc7a4bf7522f.png";
const imgC57F92CeCa5E4Db59F77D47C3F86F3Da1 = "./assets/figma/5c71c10c-4243-4cf8-bdb0-23718a367eb8.png";
const img65725C2E9E3643FcB8D3D3559F8C7E501 = "./assets/figma/06a609ca-f492-4de3-aaa2-439450ea0117.png";
const img067A3De953C04Ae59Bea5D5D90E5B8B71 = "./assets/figma/376e909c-c2bf-447d-93b1-666a13de089d.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/12bba834-9dfb-408a-831d-4e0f805933eb.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle246 = "./assets/figma/5739c19d-a8c6-4a57-b818-fdb5339a6092.svg";
const imgRectangle247 = "./assets/figma/99e09d76-9d1a-40f9-a7b6-5916ffc59faa.svg";
const imgClose = "./assets/figma/5b44e52d-c0c4-454a-acee-7c6150af57b5.svg";

export default function TeamGraphic2Guidecards() {
  return (
    <div className="s0 s1" data-node-id="875:2541" data-name="TEAM_GRAPHIC_2/GUIDECARDS">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s826 s827 s9 s10 s662" src={imgTeamGraphic2Guidecards} />
        </div>
      </div>
      <div className="s2 s12 s828 s829 s15" data-node-id="875:2543" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s830 s831 s22" data-node-id="875:2544">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="875:2545">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:2546">
            PROJECT OVERVIEW
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:2547">
            POSTERS · A2 · 4<br aria-hidden />
            GUIDE CARDS · 160 × 100 MM · 9<br aria-hidden />
            POSTCARDS · 100 × 150 MM · 8<br aria-hidden />
            <br aria-hidden />
          </p>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="875:2548">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="875:2549">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:2550">
            MEMBERS
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:2551">
            강다원
            <br aria-hidden />
            고이룸
            <br aria-hidden />
            박성연
            <br aria-hidden />
            박세현
          </p>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s832 s27 s29 s33 s833 s54" data-node-id="875:2552">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s834 s27 s29 s835 s57" data-node-id="875:2553">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="875:2554">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="875:2555">
          <p className="s39 s40">{`그래픽 2팀은 유리관을 연결하고 조립한 타이포그래피로 DING AI LAB의 이름과 실험실이라는 공간적 특성을 시각화했다. `}</p>
          <p className="s39 s40">{`기하학적 형태와 색의 그라데이션이 겹치고 어우러지는 배경을 통해 다양한 아이디어가 모여 조화를 이루는 모습을 표현했으며, `}</p>
          <p className="s39 s40">{`텍스트를 그래픽과 연결해 활동 순서와 슬로건의 정보 위계를 정리했다. 엽서에는 서로 다른 AI의 특성과 아이디어가 변화·확장되는 과정을 `}</p>
          <p className="s39 s40">{`고유 색상, 투명 파이프와 구체로 담았다. 8가지 AI 가이드 카드에는 핵심 기능, 활용 분야, 프롬프트 예시, 사용 팁과 주의사항을 캐릭터와 `}</p>
          <p className="s39">{`색상으로  구분해 복잡한 정보를 친근하고 명확하게 전달했다.`}</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s836 s27 s29 s61 s837 s54" data-node-id="875:2556">
        GRAPHIC 2
      </p>
      <div className="s2 s623 s838 s835 s625" data-node-id="875:2557" data-name="이미지 1203 2">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img12032} />
      </div>
      <p className="s23 s2 s31 s32 s839 s27 s29 s64 s840 s66" data-node-id="875:2558">
        WORK
      </p>
      <div className="s2 s16 s17 s627 s18 s36 s839 s841 s66" data-node-id="875:2559">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2560">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2561" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2562" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2563" />
          <p className="s23 s192 s31 s32 s667 s346 s27 s0 s198 s29 s33 s85 s668" data-node-id="875:2564">
            POSTER 1
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2565">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2566" data-name="이미지 2026. 9. 2. 오후 3.37 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s629 s630 s9 s631 s632" src={img2026923372} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s653 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2567" />
          <div className="s80 s192 s81 s69 s633 s340 s82 s0 s70 s198 s71" data-node-id="875:2568" />
          <p className="s23 s192 s31 s94 s669 s346 s27 s0 s198 s29 s33 s85 s304" data-node-id="875:2569">
            POSTER 2
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2570">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2571" data-name="이미지 2026. 9. 2. 오후 3.37 3">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s634 s635 s9 s636 s637" src={img2026923373} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:2572" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2573" />
          <p className="s23 s192 s31 s94 s670 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:2574">
            POSTER 3
          </p>
        </div>
      </div>
      <div className="s2 s16 s17 s627 s18 s36 s839 s842 s66" data-node-id="875:2575">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2576">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2577" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s640 s9 s641 s343" src={img2026923383} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2578" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2579" />
          <p className="s23 s192 s31 s32 s671 s346 s27 s0 s198 s29 s33 s85 s672" data-node-id="875:2580">
            POSTER 4
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2581">
          <div className="s192 s69 s673 s340 s0 s70 s198 s71" data-node-id="875:2582" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s674 s675 s9 s676 s677" src={img2026923384} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2583" />
          <div className="s80 s192 s81 s69 s647 s340 s82 s0 s70 s198 s71" data-node-id="875:2584" />
          <p className="s23 s192 s31 s94 s678 s346 s27 s0 s198 s29 s33 s85 s679" data-node-id="875:2585">
            GUIDE CARDS
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2586">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2587" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s7 s680 s9 s10 s681" src={img2026923385} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:2588" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2589" />
          <p className="s23 s192 s31 s94 s682 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:2590">
            POSTCARDS
          </p>
        </div>
      </div>
      <div className="s2 s102 s843 s10 s104" data-node-id="875:2591">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s844 s108 s109" data-node-id="875:2592" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="875:2593">
          <div className="s111 s0 s28 s112" data-node-id="875:2594" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="875:2599">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="875:2600">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="875:2601">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2602">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2603">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="875:2604">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2605">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2606">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="875:2607">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2608">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2609">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s106 s2 s125 s845 s10 s104" data-node-id="875:2610">
        <div className="s2 s127">
          <img alt="" className="s49 s9 s1" src={imgRectangle246} />
        </div>
      </div>
      <div className="s106 s2 s128 s845 s10 s104" data-node-id="875:2611">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle247} />
        </div>
      </div>
      <div className="s2 s16 s17 s24 s130 s26 s846 s132 s133" data-node-id="875:2710" data-name="PROJECT_CATEGORY_TABS_GRAPHIC2">
        <p className="s23 s31 s32 s379 s27 s0 s28 s137 s138 s380" data-node-id="875:2711">
          GRAPHIC 2
        </p>
        <div className="s16 s17 s139 s18 s0 s28 s847" data-node-id="856:3224" data-name="PROJECT_CATEGORY_TABS_GRAPHIC2">
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3225" data-name="TAB_POSTER1">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3226">
              POSTER 1
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3227" data-name="TAB_POSTER2">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3228">
              POSTER 2
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3229" data-name="TAB_POSTER3">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3230">
              POSTER 3
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3231" data-name="TAB_POSTER4">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3232">
              POSTER 4
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="856:3233" data-name="TAB_GUIDECARDS">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="856:3234">
              GUIDE CARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3235" data-name="TAB_POSTCARDS">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3236">
              POSTCARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
        </div>
      </div>
      <button className="s2 s49 s141 s211 s212 s213" data-node-id="908:225" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
      <div className="s2 s67 s153 s848" data-node-id="1032:502">
        <div className="s2 s5 s849 s153 s156 s157 s848 s158" data-node-id="1032:503" />
        <p className="s23 s2 s31 s32 s850 s27 s29 s160 s851 s54" data-node-id="1032:504">
          GUIDE CARDS
        </p>
        <div className="s106 s2 s67 s852 s853" data-node-id="1032:505">
          <div className="s106 s2 s854 s852 s165 s4 s145 s146 s853 s855" data-node-id="1032:506">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s856 s26 s857 s27 s29 s858 s859" data-node-id="1032:507">
            <div className="s16 s17 s24 s172 s26 s0 s28 s860" data-node-id="1032:508">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="1032:509">
                Prompt
              </p>
              <div className="s35 s36 s0 s28 s861 s34 s38" data-node-id="1032:510">
                <p className="s175 s40 s174">Create a high-resolution 3D character for the DING AI LAB character series.</p>
                <p className="s175 s40 s174">Show one complete character centered and facing directly forward.</p>
                <p className="s175 s40 s174">Keep the entire character visible, including the head ornament, feet, side antennas, rods, and spheres. Leave comfortable and even margins around the character.</p>
                <p className="s175 s40 s174">The character has a soft, fluffy body with detailed fur, a glossy black rounded face screen, glowing pixel-art eyes, and futuristic glass-and-metal accessories. Use clean studio lighting, polished materials, crisp details, and a cute but sophisticated design.</p>
                <p className="s175 s40 s174">Background: solid pure white (#FFFFFF), seamless studio back-ground.</p>
                <p className="s175 s40 s174">Character only. No text, numbers, captions, logos, borders, interface graphics, or additional characters. Do not crop any part of the char-acter. Add only a subtle natural contact shadow directly beneath the feet. Premium high-resolution 3D render.</p>
                <p className="s175 s40 s174">​</p>
                <p className="s175 s40 s174">[네거티브 프롬프트]</p>
                <p className="s175 s40 s174">​</p>
                <p className="s175 s174">No text, numbers, captions, logos, borders, interface graphics, or additional characters.Do not crop any part of the character.</p>
              </div>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="1032:511">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="1032:512">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="1032:513">
                Chat GPT
              </p>
            </div>
          </div>
        </div>
        <div className="s2 s862 s863 s864 s865" data-node-id="1032:514" data-name="-15.png 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img15Png1} />
        </div>
        <div className="s2 s866 s867 s868 s869" data-node-id="1032:515" data-name="-16.png 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img16Png1} />
        </div>
        <p className="s23 s2 s31 s32 s870 s27 s29 s137 s871 s54" data-node-id="1032:516">
          GUIDE CARDS DESIGN
        </p>
        <div className="s2 s872 s863 s853 s873" data-node-id="1032:517" data-name="-12 1">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s874 s875 s9 s876 s877" src={img121} />
          </div>
        </div>
        <div className="s2 s878 s879 s880 s881" data-node-id="1032:518" data-name="-12 3">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s882 s875 s9 s883 s877" src={img121} />
          </div>
        </div>
        <div className="s2 s884 s885 s886 s887" data-node-id="1032:519" data-name="-12 2">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s888 s889 s9 s890 s891" src={img121} />
          </div>
        </div>
        <div className="s2 s892 s893 s894 s895" data-node-id="1032:520" data-name="-12 4">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s896 s889 s9 s897 s891" src={img121} />
          </div>
        </div>
        <p className="s23 s2 s31 s32 s898 s27 s29 s137 s899 s54" data-node-id="1032:521">
          CHARACTER DESIGN
        </p>
      </div>
      <div className="s2 s900 s901 s185 s902 s187 s903 s189 s904 s905" data-node-id="1032:501">
        <div className="s906 s192 s197 s0 s198 s28" data-node-id="1032:482" data-name="B2DF6876-6D69-42FD-A6E8-2737476A81E5 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgB2Df68766D6942FdA6E82737476A81E51} />
        </div>
        <div className="s906 s203 s197 s0 s198 s28" data-node-id="1032:483" data-name="06A88D4F-CCCE-45EE-9F24-94B91A083358 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img06A88D4FCcce45Ee9F2494B91A0833581} />
        </div>
        <div className="s906 s907 s197 s0 s198 s28" data-node-id="1032:485" data-name="31FE81D3-DA82-4D54-8671-6FBD4D48C002 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img31Fe81D3Da824D5486716Fbd4D48C0021} />
        </div>
        <div className="s906 s908 s197 s0 s198 s28" data-node-id="1032:486" data-name="90CC8E1E-4706-4DDD-945F-67B8DA51C4D6 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img90Cc8E1E47064Ddd945F67B8Da51C4D61} />
        </div>
        <div className="s906 s205 s197 s0 s198 s28" data-node-id="1032:484" data-name="A35715BC-EFDA-49A4-9D8E-82DF03968D50 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgA35715BcEfda49A49D8E82Df03968D501} />
        </div>
        <div className="s906 s909 s197 s0 s198 s28" data-node-id="1032:487" data-name="1C7920CD-BDB1-4369-A01E-4B60B7E0F0DF 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img1C7920CdBdb14369A01E4B60B7E0F0Df1} />
        </div>
        <div className="s910 s911 s197 s0 s198 s28" data-node-id="1032:488" data-name="92C4E9F6-0FED-48D8-A273-F8F5B32C821C 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img92C4E9F60Fed48D8A273F8F5B32C821C1} />
        </div>
        <div className="s910 s912 s197 s0 s198 s28" data-node-id="1032:489" data-name="9CDC4E6B-87D2-4719-A321-E1F4152D1C8D 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img9Cdc4E6B87D24719A321E1F4152D1C8D1} />
        </div>
        <div className="s906 s913 s197 s0 s198 s28" data-node-id="1032:490" data-name="DA3E057C-95CC-44C8-AB31-B10703C92C95 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgDa3E057C95Cc44C8Ab31B10703C92C951} />
        </div>
        <div className="s906 s192 s197 s0 s206 s28" data-node-id="1032:491" data-name="9E2BBB1C-4F5F-4835-A412-EE904CCA1209 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img9E2Bbb1C4F5F4835A412Ee904Cca12091} />
        </div>
        <div className="s906 s203 s197 s0 s206 s28" data-node-id="1032:492" data-name="E143E6B0-B96B-402D-9315-B91D7293DD2E 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgE143E6B0B96B402D9315B91D7293Dd2E1} />
        </div>
        <div className="s906 s205 s197 s0 s206 s28" data-node-id="1032:493" data-name="4E95026A-ED71-46AD-B74A-EE7C976AB2FD 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img4E95026AEd7146AdB74AEe7C976Ab2Fd1} />
        </div>
        <div className="s906 s907 s197 s0 s206 s28" data-node-id="1032:494" data-name="B6B883AD-3BEA-4450-A001-99614F62FB77 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgB6B883Ad3Bea4450A00199614F62Fb771} />
        </div>
        <div className="s906 s908 s197 s0 s206 s28" data-node-id="1032:495" data-name="1F045125-DB60-4EF9-8344-E667C966F24A 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img1F045125Db604Ef98344E667C966F24A1} />
        </div>
        <div className="s906 s909 s197 s0 s206 s28" data-node-id="1032:497" data-name="C043DDF8-D37F-4BE0-952B-565204E4ABD4 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgC043Ddf8D37F4Be0952B565204E4Abd41} />
        </div>
        <div className="s910 s911 s197 s0 s206 s28" data-node-id="1032:498" data-name="C57F92CE-CA5E-4DB5-9F77-D47C3F86F3DA 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgC57F92CeCa5E4Db59F77D47C3F86F3Da1} />
        </div>
        <div className="s910 s912 s197 s0 s206 s28" data-node-id="1032:499" data-name="65725C2E-9E36-43FC-B8D3-D3559F8C7E50 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img65725C2E9E3643FcB8D3D3559F8C7E501} />
        </div>
        <div className="s906 s913 s197 s0 s206 s28" data-node-id="1032:500" data-name="067A3DE9-53C0-4AE5-9BEA-5D5D90E5B8B7 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img067A3De953C04Ae59Bea5D5D90E5B8B71} />
        </div>
      </div>
    </div>
  );
}